import React from 'react';
import { Form, Image } from 'react-bootstrap';
import { ProviderData } from '@/common/types';
import FileUploadField from '@/portal/components/FileUploadField.tsx';
import { useImagePreview } from '@/portal/hooks/useImagePreview.ts';

interface PhotoUploadFieldProps {
  provider?: ProviderData;
  className?: string;
}

const PhotoUploadField: React.FC<PhotoUploadFieldProps> = ({
  provider = null,
}) => {
  const { previewUrl, handlePreviewFileChange } = useImagePreview(
    provider?.photoUrl
  );

  return (
    <Form.Group className="mb-3" controlId="photo">
      <Form.Label>Profile Photo</Form.Label>
      <div className="d-flex flex-column gap-2">
        <Image
          src={previewUrl || '/images/placeholder-avatar.svg'}
          className="rounded-5 shadow-sm d-block"
          style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
        />
        <FileUploadField
          name="photo"
          onChange={(file: File | null) => {
            handlePreviewFileChange(file, provider?.photoUrl);
          }}
          onDeleteExisting={() => handlePreviewFileChange(null)}
          onRestoreExisting={() =>
            handlePreviewFileChange(null, provider?.photoUrl)
          }
          accept="image/jpeg,image/png"
          existingFile={provider?.photoUrl}
        />
      </div>
    </Form.Group>
  );
};

export default PhotoUploadField;
